import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import AppLayoutWrapFull from "components/AppLayoutWrapFull";
import Container from "components/Container/Container";
import PageHeader from "components/PageHeader/PageHeader";
import AddOrgModal from "./AddOrgModal/AddOrgModal"
import AddSiteModal from "./AddSiteModal/AddSiteModal"
import PageHeaderActions from "components/PageHeader/components/PageHeaderActions/PageHeaderActions";
import OrgSiteDeptSites from "./OrgSiteDeptSites";
import OrgSiteDeptEditForm from "./OrgSiteDeptEditForm";
import { updateOrgAction, updateSiteAction, loadOrgSiteDeptAction } from "store/actions/Actions";
import { transformOrganizations } from "./utils";
import { toggleDropdowns } from "helpers/utils";
import styles from "./OrgSiteDept.module.scss";
import EditOrgModal from "./EditOrgModal/EditOrgModal";
import BulkUploadModal from "./BulkUploadModal/BulkUploadModal";

const OrgSiteDept = props => {
    const [state, setState] = useState(() => ({
        actions:
            "Add actions as obj here, or add as separate properties to state",
        selectedRows: null,
        organizations: null
    }));
    const [showModal, setShowModal] = useState(false);
    const [showActsModal, setShowActsModal] = useState(false);
    const [showSiteModal, setShowSiteModal] = useState(false);
    const [showBulkUploadModal, setShowBulkUploadModal] = useState(false);

    const { UserOrgSiteReducer, OrgSiteDeptReducer, loadOrgSiteDeptAction, updateOrgAction, updateSiteAction } = props;

    useEffect(() => {
        if (!OrgSiteDeptReducer.organizations) {
            loadOrgSiteDeptAction();
        }
    }, [OrgSiteDeptReducer.organizations, loadOrgSiteDeptAction]);

    useEffect(() => {
        if (OrgSiteDeptReducer.organizations) {
            setState(s => ({
                ...s,
                organizations: OrgSiteDeptReducer.organizations,
                sitesData: transformOrganizations(OrgSiteDeptReducer.organizations)
            }));
        }
    }, [OrgSiteDeptReducer.organizations, loadOrgSiteDeptAction]);

    const [formData, setFormData] = useState({
        company_name: "",
        id: "",
        address_1: "",
        type: "",
        address_2: "",
        city: "",
        region: "",
        country_code: "235",
        postal_code: "",
        site_limit: "",
        "profile-photo": "",
        "profile-photo-filename": "Add/Upload New"
    });

    const countryDropdownToggleRef = React.createRef();
    const is_super = (UserOrgSiteReducer.selected && UserOrgSiteReducer.selected.is_super && !UserOrgSiteReducer.selected.is_site_admin) || false;
    const is_site_admin = (UserOrgSiteReducer.selected && UserOrgSiteReducer.selected.is_site_admin) || false;

    return (
        <AppLayoutWrapFull
            onClick={toggleDropdowns([countryDropdownToggleRef])}
        >
            <PageHeader showStats={true}>
                {UserOrgSiteReducer && UserOrgSiteReducer.selected && !UserOrgSiteReducer.selected.is_officer && UserOrgSiteReducer.selected.is_admin && UserOrgSiteReducer.selected.is_super
                    ? <PageHeaderActions
                        primaryButtonText="CREATE ORGANIZATION"
                        primaryButtonHandler={() => {
                            setShowModal(true);
                        }}
                        secondaryButtonText="CREATE SITE"
                        secondaryButtonHandler={() => {
                            setShowSiteModal(true);
                        }}
                        terianryButtonText="EDIT ACTS"
                        terianryButtonHandler={() => {
                            setShowActsModal(true);
                        }}
                        fourthButtonText="BULK UPLOAD"
                        fourthButtonHandler={() => {
                            setShowBulkUploadModal(!showBulkUploadModal)
                        }}
                        searchValue={false}
                        noFilter={true}
                    />
                    : ''
                }
                {UserOrgSiteReducer && UserOrgSiteReducer.selected && UserOrgSiteReducer.selected.is_officer
                    ? <PageHeaderActions
                        // primaryButtonText="CREATE ORGANIZATION"
                        // primaryButtonHandler={() => {
                        //     setShowModal(true);
                        // }}
                        // secondaryButtonText="CREATE SITE"
                        // secondaryButtonHandler={() => {
                        //     setShowSiteModal(true);
                        // }}
                        terianryButtonText="EDIT ACTS"
                        terianryButtonHandler={() => {
                            setShowActsModal(true);
                        }}
                        // fourthButtonText="BULK UPLOAD"
                        // fourthButtonHandler={() => {
                        //     setShowBulkUploadModal(!showBulkUploadModal)
                        // }}
                        searchValue={false}
                        noFilter={true}
                    />
                    : ''
                }
            </PageHeader>
            <Container wide fluid>
                {showBulkUploadModal &&
                    <BulkUploadModal setShowModal={setShowBulkUploadModal} />
                }
                <div className={styles['organizations-wrap']}>
                    <h2>Organizations / Sites / Departments</h2>
                    <div className={styles["org-info-holder"]}>
                        <div className={styles["org-sites"]}>
                            {state.organizations ? (
                                <div>
                                    <OrgSiteDeptSites
                                        sitesData={state.sitesData}
                                        setFormData={setFormData}
                                        state={state}
                                        setState={setState}
                                        isSiteAdmin={is_site_admin}
                                    />
                                </div>
                            ) : ''}
                        </div>
                        <div className={styles["org-info"]}>
                            <OrgSiteDeptEditForm
                                isSuper={is_super}
                                isSiteAdmin={is_site_admin}
                                formData={formData}
                                setFormData={setFormData}
                                updateOrgAction={updateOrgAction}
                                updateSiteAction={updateSiteAction}
                                countryDropdownToggleRef={countryDropdownToggleRef}
                                country={formData.country_code}
                            />
                        </div>
                    </div>
                </div>
            </Container>
            {showModal ? <AddOrgModal setShowModal={setShowModal} /> : null}
            {showSiteModal ? <AddSiteModal setShowModal={setShowSiteModal} /> : null}
            {showActsModal ? <EditOrgModal setShowModal={setShowActsModal} /> : null}
        </AppLayoutWrapFull>
    );
};

const mapStateToProps = (state) => ({
    OrgSiteDeptReducer: state.OrgSiteDeptReducer,
    UserOrgSiteReducer: state.UserOrgSiteReducer,
});

const mapDispatchToProps = {
    updateOrgAction,
    updateSiteAction,
    loadOrgSiteDeptAction
};

export default withRouter(
    connect(
        mapStateToProps,
        mapDispatchToProps
    )(OrgSiteDept)
);
